export const MainWorldSprite = (
  <rect width={10440} height={6000} fill="#95BB5D" />
);
